export enum PresenceStateConstants {
  Login = 1,
  Logout = 2,
  PortalMain = 3,
  Reports = 4,
  Timesheets = 5,
  UpdateDetails = 6,
  Scheduling = 7,
  Training = 8,
  Telephony = 9,
  AvailableIB = 10,
  AvailableOB = 11,
  TalkIB = 12,
  TalkOB = 13,
  WrapIB = 14,
  WrapOB = 15,
  HoldIB = 16,
  HoldOB = 17,
  TransferIB = 18,
  TransferOB = 19,
  Dialling = 20,
  Ringing = 21,
  Preview = 22,
  General = 23,
  UnavailableIB = 24,
  UnavailableOB = 25,
  Standby = 26,
  ConnectIB = 27,
  ConnectOB = 28,
  IBMissedCall = 29,
  AvailableChat = 434,
  UnavailableChat = 435,
  Offline = 685,
  Heartbeat = 694,
  Refresh = 984,
  IBTransferOnly = 985,
  Idle = 986,
  Voicemail = 987,
  UAT = 1002,
}
